import React from "react"
import FieldInlineEditable, {FieldInlineEditableProps} from "../../../../render/inline-editable"
import FieldsFactory from "../../../../fields-factory"
import {FieldType} from "../../../../field-type"
import {ReportDate} from "../model/model"

const debug = false
// const debug = "FieldAgileReportDate_InlineEditable"

export default class FieldAgileReportDate_InlineEditable extends React.Component<FieldInlineEditableProps, any>{

    onPresetChange = (lastDays:number) => {
        const reportDate : ReportDate = this.props.field.getViewValue(this.props.model)

        if (!lastDays) {
            reportDate.startDate    = momentDate().subtract(reportDate.lastDays,'days')
            reportDate.endDate      = momentDate()

            debug && console.log(debug, "onPresetChange: custom", reportDate.lastDays, reportDate.startDate, reportDate.endDate)
        } else {
            reportDate.startDate    = null
            reportDate.endDate      = null
        }

        reportDate.lastDays     = lastDays

        debug && console.log(debug, "onPresetChange",reportDate)

        this.forceUpdate()
    }

    onDateRangeChange = (dateRange: any) => {
        const reportDate : ReportDate = this.props.field.getViewValue(this.props.model)
        reportDate.startDate  = dateRange.start
        reportDate.endDate    = dateRange.end

        debug && console.log(debug, "onDateRangeChange",dateRange)
    }

    render() {
        const reportDate : ReportDate = this.props.field.getViewValue(this.props.model)

        debug && console.log(debug, "render value", reportDate, this.props.field.fieldId, this.props.model)

        const presetRangeSelector = FieldsFactory.get({
            fieldId             : 'lastDays',
            type                : FieldType.DROPDOWN,
            label               : 'Date range',
            options             : this.props.field.options,
            noValueOption       : false,
            showMenuMore        : false
        })

        const dateRangeSelector = FieldsFactory.get({
            fieldId         : 'dateRange',
            type            : FieldType.DATE_RANGE,
            maxDate         : momentDate(),
            clearButton     : false,
        })

        const dateRangeModel = !reportDate.lastDays && reportDate.startDate && reportDate.endDate ?
            {dateRange: {start: reportDate.startDate, end: reportDate.endDate}}
            :
            null

        debug && console.log(debug, "render dateRange", dateRangeModel)

        const displayDaterangeSelector = !reportDate.lastDays


        if (!displayDaterangeSelector) {
            return (
                <div className={Classes("flex-row-left-center", this.props.className)}>
                    {presetRangeSelector &&
                        <FieldInlineEditable field     = {presetRangeSelector}
                                             model     = {reportDate}
                                             onChange  = {this.onPresetChange}/>}
                </div>
            )

        } else {
            return (
                <div className={Classes("flex-column-left-top p-t-5", this.props.className)}>
                    {presetRangeSelector &&
                        <FieldInlineEditable field={presetRangeSelector}
                                             model={reportDate}
                                             onChange={this.onPresetChange}/>}

                    {dateRangeSelector && !reportDate.lastDays &&
                        <FieldInlineEditable className="m-t-5"
                                             field={dateRangeSelector}
                                             model={dateRangeModel}
                                             onChange={this.onDateRangeChange}/>}
                </div>
            )
        }
    }
}